import React, { useState } from 'react';
import {
  Breadcrumb,
  Button,
  ConfigProvider,
  Form,
  Input,
  Space,
  Switch,
} from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import { createNewsCategoryRequest } from 'modules/newsModule/requests/newsRequests';

const NewsCategoriesAdd = (): JSX.Element => {
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const onSubmitForm = (values: any) => {
    toggleButtonLoading(true);
    createNewsCategoryRequest(values).then(() => toggleButtonLoading(false));
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Aktualności</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/news/categories">Kategorie</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/news/categories/add">Dodaj kategorię</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <div className="site-layout-background">
        <ConfigProvider locale={plPL}>
          <Form
            layout="vertical"
            validateMessages={validateMessages}
            onFinish={onSubmitForm}
          >
            <Form.Item name="id" hidden>
              <Input />
            </Form.Item>
            <Form.Item
              name="name"
              label="Nazwa"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sortOrder"
              label="Kolejność"
              rules={[
                {
                  required: true,
                },
                {
                  validator: async (_, value) => {
                    if (value) {
                      if (
                        (value.length > 5 ||
                          !/^[0-9]*\,?\.?[0-9]*$/.test(value)) &&
                        value.length > 0
                      ) {
                        return Promise.reject(
                          new Error('Proszę podać poprawną wartość!')
                        );
                      }
                    }
                  },
                },
              ]}
            >
              <Input
                style={{
                  width: '100px',
                }}
              />
            </Form.Item>
            <Form.Item
              name="isActive"
              label="Widoczność"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  loading={isSaveButtonLoading}
                >
                  Zapisz
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </ConfigProvider>
      </div>
    </>
  );
};

export default NewsCategoriesAdd;
